module.exports = __webpack_public_path__ + "mdkt2018/img/score.027238d.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/score/img/score.png
// module id = 4K8E
// module chunks = 1